module.exports = __webpack_public_path__ + "media/images/hatena-cbf88450d990fcccc32a7cd889454e61.png";